export default __webpack_public_path__ + "static/media/home-restaurant-img-20.44ffe974.jpg";